import { EThemeType } from "redux/reducers";
interface IProp {
  theme?: EThemeType;
  className?: string;
}

export const RegenerateIcon = ({ theme }: IProp) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M8.82312 5.65414C8.69742 5.61494 8.56134 5.62705 8.44453 5.68783C8.32772 5.74861 8.23966 5.85313 8.19955 5.97862C7.96387 6.69969 7.50442 7.32671 6.88803 7.76844C6.27165 8.21017 5.53049 8.44356 4.77239 8.43466C3.83471 8.44533 2.93107 8.08346 2.25963 7.4284C1.58818 6.77334 1.20373 5.87857 1.19059 4.94029C1.20373 4.002 1.58818 3.10723 2.25963 2.45217C2.93107 1.79712 3.83471 1.43524 4.77239 1.44591C5.61924 1.44386 6.44003 1.73884 7.09208 2.27957L6.00956 2.09986C5.94468 2.08917 5.87833 2.09143 5.81433 2.1065C5.75033 2.12156 5.68993 2.14914 5.63662 2.18765C5.5833 2.22615 5.53812 2.27483 5.50367 2.33087C5.46922 2.38691 5.44618 2.44921 5.43587 2.51419C5.4252 2.57911 5.42745 2.64551 5.44251 2.70955C5.45756 2.7736 5.48512 2.83404 5.5236 2.88739C5.56208 2.94074 5.61072 2.98595 5.66672 3.02042C5.72273 3.0549 5.78499 3.07795 5.84992 3.08827L7.96508 3.4377H8.04989C8.10773 3.43764 8.16513 3.4275 8.2195 3.40775C8.23777 3.40081 8.25467 3.39067 8.26939 3.3778C8.30515 3.36449 8.33877 3.34599 8.36916 3.32289L8.41405 3.26798C8.41405 3.24302 8.45895 3.22305 8.47891 3.1931C8.49886 3.16315 8.47891 3.14318 8.50385 3.12321C8.51763 3.09414 8.5293 3.06411 8.53877 3.03336L8.91291 1.03657C8.92536 0.971013 8.92478 0.903646 8.91121 0.838314C8.89764 0.772982 8.87134 0.710965 8.83382 0.655803C8.7963 0.600641 8.74829 0.553414 8.69253 0.51682C8.63677 0.480226 8.57435 0.45498 8.50884 0.442524C8.44333 0.430069 8.37601 0.430647 8.31072 0.444227C8.24543 0.457806 8.18346 0.484121 8.12833 0.521668C8.017 0.597499 7.94033 0.714478 7.9152 0.846874L7.7805 1.57071C6.94541 0.846495 5.87745 0.447731 4.77239 0.447516C3.57011 0.436867 2.41271 0.90393 1.55416 1.74622C0.695607 2.5885 0.206036 3.73721 0.192871 4.94029C0.206036 6.14336 0.695607 7.29207 1.55416 8.13436C2.41271 8.97664 3.57011 9.4437 4.77239 9.43306C5.74673 9.44804 6.70013 9.14957 7.49223 8.58161C8.28433 8.01364 8.87326 7.20619 9.17232 6.27813C9.19124 6.21422 9.19718 6.14716 9.18979 6.08092C9.18239 6.01467 9.16182 5.95058 9.12927 5.89242C9.09672 5.83426 9.05286 5.78321 9.00028 5.74229C8.9477 5.70136 8.88746 5.67139 8.82312 5.65414Z"
        fill={theme === "dark" ? "#fff" : "#2A2831"}
      />
    </svg>
  );
};

export const AmplifierIcon = ({ theme }: IProp) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_17192_27624)">
      <path
        d="M13.5841 4.22266C14.8339 5.47284 15.536 7.16823 15.536 8.93599C15.536 10.7038 14.8339 12.3991 13.5841 13.6493M11.2308 6.57599C11.8557 7.20108 12.2067 8.04878 12.2067 8.93266C12.2067 9.81654 11.8557 10.6642 11.2308 11.2893M8.2041 4.26932L4.87077 6.93599H2.2041V10.936H4.87077L8.2041 13.6027V4.26932Z"
        stroke={theme === "dark" ? "white" : "currentColor"}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17192_27624">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.871094 0.935547)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const StopIcon = ({ theme }: IProp) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <path
      d="M6.80713 12.4355C9.8447 12.4355 12.3071 9.97311 12.3071 6.93555C12.3071 3.89798 9.8447 1.43555 6.80713 1.43555C3.76956 1.43555 1.30713 3.89798 1.30713 6.93555C1.30713 9.97311 3.76956 12.4355 6.80713 12.4355Z"
      stroke={theme === "dark" ? "white" : "currentColor"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.35938 5.19922V8.6729"
      stroke={theme === "dark" ? "white" : "currentColor"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.25488 5.19922V8.6729"
      stroke={theme === "dark" ? "white" : "currentColor"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LoadingIcon = ({ className = "", theme }: IProp) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_17068_25959)">
      <path
        d="M8.37077 2.26831V4.93498M8.37077 12.935V15.6016M3.65743 4.22164L5.5441 6.10831M11.1974 11.7616L13.0841 13.6483M1.7041 8.93498H4.37077M12.3708 8.93498H15.0374M3.65743 13.6483L5.5441 11.7616M11.1974 6.10831L13.0841 4.22164" 
      stroke={theme === "dark" ? "white" : "currentColor"}
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17068_25959">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.371094 0.934937)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DownIcon = ({ theme }: IProp) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="none">
      <path d="M1 0.933594L3.5 2.93359L6 0.933594" stroke={theme === "dark" ?"white":"#192126"} stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}